import useOrgRoleMultiSelect from './UseOrgRoleMultiSelect';
import MultiSelect from '../MultiSelect';

const OrgRoleMultiSelect = ({ label, name, value, error, message, onChange }) => {
  const { options } = useOrgRoleMultiSelect();

  return (
    <MultiSelect
      label={label}
      name={name}
      value={value}
      options={options}
      error={error}
      message={message}
      isLoading={false}
      onChange={onChange}
    />
  );
}

export default OrgRoleMultiSelect;